import { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Toolbar,
  ToolbarItem,
  ToolbarSeparator,
  Button,
} from "@progress/kendo-react-buttons";
import { Form, FormElement } from "@progress/kendo-react-form";
import { WidgetSettingsFormDataSource } from "./widgetsettingsformdatasource";
import { CardNumericWidgetSettings } from "../../../components/widgets/cardnumericwidgetsettings";
import { CardDateWidgetSettings } from "../../../components/widgets/carddatewidgetsettings";
import { CardGaugeWidgetSettings } from "../../../components/widgets/cardgaugewidgetsettings";
import { GridWidgetSettings } from "../../../components/widgets/gridwidgetsettings";
import { GenericChartWidgetSettings } from "../../../components/widgets/genericchartwidgetsettings";
import { TickerWidgetSettings } from "../../../components/widgets/tickerwidgetsettings";
import {
  WIDGET_NUMERIC_CARD,
  WIDGET_DATE_CARD,
  WIDGET_GAUGE_CARD,
  WIDGET_GRID,
  isChart,
  WIDGET_LINE_CHART,
  WIDGET_TICKER,
} from "../../../components/widgets/utils";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const WidgetSettingsForm = (props) => {
  const {
    pageState,
    formState,
    onDatasetChange,
    onDataSourceChange,
    onAggregateExpressionChange,
    onPrevious,
    onNext,
    formValidator,
    onSettingsFormFieldValueChange,
    onSave,
    onClose,
    t,
    onTickerFieldsReorder,
    ...other
  } = props;

  const currentTheme = useSelector((state) => state.currentTheme); 
  const appearance = useSelector((state) => state.appearance); 

  return (
    <Fragment>
      <div className="widget-settings-form">
        <Form
          validator={formValidator}
          key={formState.formKey}
          initialValues={formState.formInitialValues}
          render={(formRenderProps) => {
            return (
              <FormElement
                horizontal={false}
                style={
                  {
                    // width: 250,
                  }
                }
              >
                <div className="toolbar">
                  <Toolbar>
                    {formState.pageIndex > 0 && formState.mode == 1 && (
                      <Fragment>
                        <ToolbarItem>
                          <Button
                            disabled={pageState.processing}
                            style={{ color: currentTheme.primary }}
                            icon="arrow-60-left"
                            onClick={onPrevious}
                          >
                            {t("reporting.design.previous")}
                          </Button>
                        </ToolbarItem>
                        <ToolbarSeparator />
                      </Fragment>
                    )}
                    {formState.pageIndex == 0 && formState.mode == 1 && (
                      <Fragment>
                        <ToolbarItem>
                          <Button
                            disabled={
                              pageState.processing ||
                              formState.formValues.datasetId < 1 ||
                              (formState.formValues.dataSourceId < 1 &&
                                formState.formValues.aggregateExpressionId < 1)
                            }
                            style={{ color: currentTheme.primary }}
                            icon="arrow-60-right"
                            onClick={(e) => onNext(e, formRenderProps)}
                          >
                            {t("reporting.design.next")}
                          </Button>
                        </ToolbarItem>
                        <ToolbarSeparator />
                      </Fragment>
                    )}
                    {formState.pageIndex == 1 && (
                      <Fragment>
                        <ToolbarItem>
                          <Button
                            disabled={pageState.processing}
                            style={{ color: currentTheme.primary }}
                            icon="save"
                            onClick={onSave}
                          >
                            {t("reporting.design.save")}
                          </Button>
                        </ToolbarItem>
                        <ToolbarSeparator />
                      </Fragment>
                    )}
                    <Fragment>
                      <ToolbarItem>
                        <Button
                          disabled={pageState.processing}
                          style={{ color: currentTheme.primary }}
                          icon="cancel"
                          onClick={onClose}
                        >
                          {t("reporting.design.cancel")}
                        </Button>
                      </ToolbarItem>
                      <ToolbarSeparator />
                    </Fragment>
                  </Toolbar>
                </div>
                <div className="form-content">
                  {formState.pageIndex == 0 && (
                    <WidgetSettingsFormDataSource
                      t={t}
                      formRenderProps={formRenderProps}
                      pageState={pageState}
                      formState={formState}
                      onDatasetChange={(e) =>
                        onDatasetChange(e, formRenderProps)
                      }
                      onDataSourceChange={(e) =>
                        onDataSourceChange(e, formRenderProps)
                      }
                      onAggregateExpressionChange={(e) =>
                        onAggregateExpressionChange(e, formRenderProps)
                      }
                    />
                  )}
                  {formState.pageIndex == 1 &&
                    formState.widgetTypeId == WIDGET_NUMERIC_CARD && (
                      <CardNumericWidgetSettings
                        pageState={pageState}
                        formState={formState}
                        onFieldValueChange={onSettingsFormFieldValueChange}
                      />
                    )}
                  {formState.pageIndex == 1 &&
                    formState.widgetTypeId == WIDGET_DATE_CARD && (
                      <CardDateWidgetSettings
                        pageState={pageState}
                        formState={formState}
                        onFieldValueChange={onSettingsFormFieldValueChange}
                      />
                    )}
                  {formState.pageIndex == 1 &&
                    formState.widgetTypeId == WIDGET_GAUGE_CARD && (
                      <CardGaugeWidgetSettings
                        pageState={pageState}
                        formState={formState}
                        onFieldValueChange={onSettingsFormFieldValueChange}
                      />
                    )}
                  {formState.pageIndex == 1 &&
                    formState.widgetTypeId == WIDGET_GRID && (
                      <GridWidgetSettings
                        pageState={pageState}
                        formState={formState}
                        onFieldValueChange={onSettingsFormFieldValueChange}
                      />
                    )}
                  {formState.pageIndex == 1 &&
                    isChart(formState.widgetTypeId) && (
                      <GenericChartWidgetSettings
                        pageState={pageState}
                        formState={formState}
                        onFieldValueChange={onSettingsFormFieldValueChange}
                        formRenderProps={formRenderProps}
                      />
                    )}
                  {formState.pageIndex == 1 &&
                    formState.widgetTypeId == WIDGET_TICKER && (
                      <TickerWidgetSettings
                        pageState={pageState}
                        formState={formState}
                        onFieldValueChange={onSettingsFormFieldValueChange}
                        onTickerFieldsReorder={onTickerFieldsReorder}
                      />
                    )}
                </div>
              </FormElement>
            );
          }}
        />
      </div>
      <style>
        {`
                    .widget-settings-form
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex: 1;
                        height: 100%;
                        direction:${appearance.isRightToLeft ? "rtl" : "ltr"}
                    }

                    /*form toolbar*/
                    .widget-settings-form .toolbar .k-toolbar
                    {
                      width: 100%;
                      border-left: none !important;
                      border-bottom: 1px solid ${currentTheme.separatorColor};
                      border-top: none !important;
                      border-right: none !important;
                      padding: 3px 4px 2px 0px;
                      background-color: ${currentTheme.appBarBg}; /*transparent;*/
                    }

                    .widget-settings-form .toolbar .k-button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                      background-color:transparent;
                    }

                    .widget-settings-form .toolbar .k-separator 
                    {
                        border-color: ${currentTheme.appBarLinkColor};/* ${currentTheme.primary}*/
                    }

                    .widget-settings-form .toolbar .k-toolbar .k-split-button:focus, .form-root .toolbar .k-toolbar .k-split-button.k-focus,
                    .widget-settings-form .toolbar .k-toolbar .k-button-solid-base:focus, .form-root .toolbar .k-toolbar .k-button-solid-base.k-focus
                    {
                        box-shadow: none !important;
                        border: none !important;
                    }

                    .widget-settings-form .toolbar .k-toolbar .k-button:active::before, .widget-settings-form .toolbar .k-toolbar .k-button:hover::before,
                    .widget-settings-form .toolbar .k-toolbar .k-button:focus::before, .widget-settings-form .toolbar .k-toolbar .k-button:focus-within::before                        
                    {
                        opacity: 0 !important;
                        border: none !important;
                        box-shadow: none !important;
                    }

                    .widget-settings-form .toolbar .k-toolbar .k-dropdown-button.k-focus .k-button::after
                    {
                        /*border: 1px solid ${currentTheme.componentBg} !important;*/
                        box-shadow: none !important;
                    }                       

                    .widget-settings-form .toolbar .k-toolbar .k-button .k-button-text
                    {
                        font-size: 13px;
                        font-weight: 400;
                        color: ${currentTheme.appBarLinkColor};//${currentTheme.componentText};
                    }

                    .widget-settings-form .toolbar .k-button-icon
                    {
                      font-weight: 500;
                      color: ${currentTheme.appBarLinkColor};/*${currentTheme.primary};*/
                    }

                    .widget-settings-form .toolbar .k-toolbar .k-button:hover .k-button-text
                    {
                        font-weight: 700;
                        font-size: 12.2px;
                    }
                    /*form toolbar*/


                    /*form content*/
                    .widget-settings-form .form-content
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        overflow: auto;
                        padding: 16px 24px;
                    }
                    /*form content*/


                    .widget-settings-form .k-form
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex: 1;
                        overflow: hidden;
                    }

                    /*utils form classes*/
                    .widget-settings-form-group
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        margin-bottom: 16px;
                        padding: 0;
                    }

                    .widget-settings-form-group > .header
                    {
                        font-size: 14px;
                        font-weight: 700;
                        padding: 6px 0 ;
                        border-bottom: 1px solid ${currentTheme.componentBorderColor};
                        margin-bottom: 6px;
                    }
                    .widget-settings-form-group > .content
                    {
                        flex:1;
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        padding: 6px 0;
                    }

                    .widget-settings-form-group > .content > .row
                    {
                        display: flex;
                        align-items: flex-end;
                        justify-content: space-between;
                        margin-bottom: 16px;
                    }

                    .widget-settings-form-group > .content > .row .k-form-field
                    {
                        margin-top: 0px;
                    }
                    /*utils form classes*/
                    

                    /*format input components*/
                    .widget-settings-form .k-form .k-label
                    {
                        font-size: 13px;
                        margin-bottom: 3px;
                    }

                    /*formatting inputs and drop down lists to make them thicker/thiner*/
                    .widget-settings-form .k-form .k-input, .k-form .k-dropdownlist
                    {                        
                        border-left: 3px solid ${currentTheme.primary};
                    }

                    .widget-settings-form .k-form .k-input, .k-form .k-dropdownlist .k-input-inner
                    {
                        background-color: ${currentTheme.componentBg};
                    }

                    .widget-settings-form .k-form .k-input
                    {
                    }

                    .widget-settings-form .k-dropdownlist button
                    {
                    }

                    .widget-settings-form .k-dropdownlist .k-input-inner
                    {
                    }

                    .widget-settings-form .k-form .k-input.k-invalid, .widget-settings-form .k-form .k-dropdownlist.k-invalid
                    {
                        border-top-color: ${currentTheme.componentBorderColor};
                        border-bottom-color: ${currentTheme.componentBorderColor};
                        border-right-color: ${currentTheme.componentBorderColor};
                    }

                    .widget-settings-form .k-form .k-input:focus, .widget-settings-form .k-form .k-input.k-textarea:focus, .widget-settings-form .k-form .k-input.k-textarea:active, .widget-settings-form .k-form .k-dropdownlist:focus
                    {
                        box-shadow: none !important;
                        outline: none;
                    }

                    .widget-settings-form .k-form .k-input-solid:focus-within
                    {
                        box-shadow: none;
                    }

                    @media (max-width: 600px)
                    {
                        .widget-settings-form .toolbar .k-toolbar
                        {
                            flex-wrap: wrap;
                            gap: 4px;
                            overflow: visible;
                            padding: 4px 6px;
                        }

                        .widget-settings-form .toolbar .k-separator
                        {
                            display: none;
                        }

                        .widget-settings-form .form-content
                        {
                            padding: 12px 16px;
                        }

                        .widget-settings-form-group > .content > .row
                        {
                            flex-wrap: wrap;
                            gap: 12px;
                        }
                    }
                    /*format input components*/
                    `}
      </style>
    </Fragment>
  );
};
